import React from 'react';
import { Button, Text, ButtonStep } from "../../Atoms";
import { COLOR_BUTTON } from "../../Config/Config";
import { IconTitleMolecule } from '../../Molecules';
import { Link } from 'react-router-dom';
import { bool, string } from 'prop-types';

const TemplatePaiementValide = ({ hasPrelevement, url }) => {  
  return (
    <div className="template-scroll template-container cotisations mt-20 d-flex flex-column">
      <div className="content-large-max">
        <IconTitleMolecule
          text="Paiement validé"
          className="title-page font-title mt-40"
          icon="alert-info"
          size='icon-x2'
        />  
        <Text
          text="Votre échéance a bien été régularisée, nous vous remercions."
          type="h8"
          className="mt-20"
        />
        <Text
          text="Si ce n'est pas encore fait, nous vous invitons à opter dès à présent pour le prélèvement automatique afin de simplifier le règlement de vos prochaines cotisations."
          type="h8"
          className="mt-20"
        />
        <Text
          text="Si vous étiez déjà en prélèvement automatique, celui-ci sera automatiquement réactivé."
          type="h8"
          className="mt-20"
        />

        {!hasPrelevement && (
          <div className="mt-20">
            <ButtonStep url={url} text="Je souhaite passer au prélèvement automatique" />
          </div>
        )}
 
        <div className="mt-40 text-center">
          <div className="text-center">
            <Link to="/" >
              <Button
                text="Retour à l'accueil de CGRM"
                className="button-big-round"
                isAlreadyOutline={true}
                color={COLOR_BUTTON.BLACK}
              />
            </Link>
          </div>
        </div>
      </div>      
    </div>
  );
}

// Validation des props
TemplatePaiementValide.propTypes = {
  hasPrelevement: bool,
  url: string,
};

export default TemplatePaiementValide;
